(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pawcare-trust-page"] && !Shopify.designMode) return;
  try {
    if (!window.pawcareTrustPagesReady) {
    window.pawcareTrustPagesReady = true;

    document.addEventListener('click', function (event) {
      const actionTarget = event.target.closest('[data-pc-trust-action]');
      const tocTarget = event.target.closest('.pc-trust-toc a');
      const target = actionTarget || tocTarget;

      if (!target) return;

      const page = target.closest('[data-pc-trust-page]');
      const eventName = actionTarget
        ? actionTarget.dataset.pcTrustAction
        : 'trust_toc_click';

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: eventName,
        trust_page: page ? page.dataset.pcTrustPage : undefined,
        link_text: target.textContent.trim(),
        link_url: target.getAttribute('href') || undefined
      });
    });

    document.addEventListener('toggle', function (event) {
      if (!event.target.matches('.pc-trust-accordion details') || !event.target.open) return;

      const page = event.target.closest('[data-pc-trust-page]');
      const summary = event.target.querySelector('summary');

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'trust_accordion_open',
        trust_page: page ? page.dataset.pcTrustPage : undefined,
        accordion_title: summary ? summary.textContent.trim() : undefined
      });
    }, true);
  }
  } catch(e) { console.error(e); }
})();

})();
